import { Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import React, { useCallback, useMemo } from 'react';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { makeStyles } from '@material-ui/core/styles';

var getWidth = function getWidth(size, defaultWidths) {
  switch (size) {
    case "small":
      return (defaultWidths === null || defaultWidths === void 0 ? void 0 : defaultWidths.small) || "20%";

    case "large":
      return (defaultWidths === null || defaultWidths === void 0 ? void 0 : defaultWidths.large) || "80%";

    case "medium":
    case undefined:
      return (defaultWidths === null || defaultWidths === void 0 ? void 0 : defaultWidths.medium) || "50%";

    default:
      return size;
  }
};

var useStyles = makeStyles(function (theme) {
  var _drawerPaperWidth;

  var _a, _b, _c, _d, _e, _f, _g;

  var desktopBreakpoint = theme.breakpoints.up("md");
  var tabletBreakpoint = theme.breakpoints.down("md");
  var mobileBreakpoint = theme.breakpoints.only("xs");
  return {
    root: Object.assign({
      padding: "50px 65px",
      height: "100%",
      overflowY: "auto",
      overflowX: "hidden"
    }, (_a = theme.sidePane) === null || _a === void 0 ? void 0 : _a.root),
    drawer: Object.assign({}, (_b = theme.sidePane) === null || _b === void 0 ? void 0 : _b.drawer),
    drawerPaperWidth: (_drawerPaperWidth = {}, _defineProperty(_drawerPaperWidth, tabletBreakpoint, {
      maxWidth: (_c = theme.sidePane) === null || _c === void 0 ? void 0 : _c.tabletWidth
    }), _defineProperty(_drawerPaperWidth, mobileBreakpoint, {
      maxWidth: (_d = theme.sidePane) === null || _d === void 0 ? void 0 : _d.mobileWidth
    }), _defineProperty(_drawerPaperWidth, desktopBreakpoint, {
      width: function width(props) {
        var _a;

        return getWidth(props.width, props.defaultWidths ? props.defaultWidths : (_a = theme.sidePane) === null || _a === void 0 ? void 0 : _a.widths);
      }
    }), _drawerPaperWidth),
    buttonBack: Object.assign({
      background: "transparent",
      padding: "0px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "transparent"
      },
      "&:focus": {
        backgroundColor: "transparent"
      }
    }, (_e = theme.sidePane) === null || _e === void 0 ? void 0 : _e.buttonBack),
    content: Object.assign({
      overflow: "hidden",
      clear: "left",
      minHeight: "calc(100% - 25px)"
    }, (_f = theme.sidePane) === null || _f === void 0 ? void 0 : _f.content),
    button: Object.assign({
      textAlign: "left"
    }, (_g = theme.sidePane) === null || _g === void 0 ? void 0 : _g.button)
  };
});

/**
 * The SidePane Component
 * Description: Open an overlayed pane from the side (side is defined in the passed props)
 * Props: see SidePaneProps in SidePane.types.tsx
 */

var SidePane = function SidePane(_ref) {
  var _ref$leftSide = _ref.leftSide,
      leftSide = _ref$leftSide === void 0 ? "right" : _ref$leftSide,
      Content = _ref.content,
      contentProps = _ref.contentProps,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$backButton = _ref.backButton,
      backButton = _ref$backButton === void 0 ? "Voltar" : _ref$backButton,
      onClose = _ref.onClose,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "medium" : _ref$width,
      defaultWidths = _ref.defaultWidths,
      keepMounted = _ref.keepMounted,
      disableEnforceFocus = _ref.disableEnforceFocus;
  var classes = useStyles({
    width: width,
    defaultWidths: defaultWidths
  });
  var close = useCallback(function (value) {
    onClose(value);
  }, [onClose]);
  var drawerClose = useCallback(function () {
    close();
  }, [close]);
  var backButtonComponent;

  if (typeof backButton === "string") {
    backButtonComponent = /*#__PURE__*/React.createElement(Button, {
      className: classes.buttonBack,
      startIcon: /*#__PURE__*/React.createElement(KeyboardBackspaceIcon, null),
      disableRipple: true,
      disableElevation: true,
      onClick: drawerClose
    }, backButton);
  } else {
    var BackButton = backButton;
    backButtonComponent = /*#__PURE__*/React.createElement(BackButton, {
      onClose: close
    });
  }

  var modalProps = useMemo(function () {
    return {
      keepMounted: keepMounted
    };
  }, [keepMounted]);
  return /*#__PURE__*/React.createElement(Drawer, {
    className: classes.drawer,
    classes: {
      paper: classes.drawerPaperWidth
    },
    variant: "temporary",
    anchor: leftSide,
    open: open,
    onClose: drawerClose,
    ModalProps: modalProps,
    disableEnforceFocus: disableEnforceFocus
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.button
  }, backButtonComponent), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Content, Object.assign({}, contentProps, {
    onClose: onClose
  })))));
};

export { SidePane };
//# sourceMappingURL=main.esm.js.map
